module.exports = __webpack_public_path__ + "img/logo.df95fee4.png";